const NOTI_PRESET = {
  default: {
    icon: 'Alarm',
    title: '알림',
    message: '새로운 알림이 있습니다.',
    buildRoute: () => '/M_AlarmList',
  },

  AL_001_001: {
    icon: '',
    title: '산업안전보건위원회 회의록 ',
    message: '회의록 참석자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/I${responseData}` : `/M_Meeting`,
  },
  AL_001_002: {
    icon: '',
    title: '산업안전보건위원회 회의록',
    message: '대표자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/I${responseData}` : `/M_Meeting`,
  },
  AL_001_005: {
    icon: '',
    title: '도급사업 안전보건 협의체 회의록',
    message: '안전보건 협의체 회의 서명 요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/C${responseData}` : `/M_Meeting`,
  },
  AL_001_006: {
    icon: '',
    title: '도급사업 안전보건 협의체 회의록',
    message: '대표자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/C${responseData}` : `/M_Meeting`,
  },
  AL_002_001: {
    icon: '',
    title: '작업허가서 ',
    message: '작업허가서가 등록되었습니다. 확인해주세요.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },

  AL_002_002: {
    icon: '',
    title: '작업허가서 반려',
    message:
      '작업허가서가 반려되었습니다. 반려 사유를 확인 후 다시 등록해주세요.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },
  AL_002_003: {
    icon: '',
    title: '작업허가서',
    message: '작업허가서가 최종 승인되었습니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },
  AL_002_004: {
    icon: '',
    title: '작업허가서 연장 신청',
    message: '작업 종료시간 연장 승인 요청이 있습니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },
  AL_003_001: {
    icon: '',
    title: '공지사항',
    message: '새 공지가 등록되었습니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Notice/detail/${responseData}` : '/M_Notice',
  },
  AL_003_002: {
    icon: '',
    title: '공지사항 수정',
    message: '공지 내용이 수정되었습니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Notice/detail/${responseData}` : '/M_Notice',
  },
  AL_006_001: {
    icon: '',
    title: '작업중지',
    useBody: true,
    message: '작업이 중지되었습니다.',
    buildRoute: () => `/`,
  },
  AL_006_002: {
    icon: '',
    title: '작업재개',
    useBody: true,
    message: '작업이 재개되었습니다.',
    buildRoute: () => `/`,
  },

  AL_007: {
    icon: '',
    title: '작업종료',
    useBody: true,
    message: '작업이 종료되었습니다.',
    buildRoute: () => '/M_WorkEnd',
  },

  AL_008: {
    icon: '',
    title: '보호구 지급',
    message: '보호구가 지급되었습니다. 확인해주세요.',
    buildRoute: () => '/M_EquipIssuanceStatus',
  },
};

export default NOTI_PRESET;
